import { SiX, SiInstagram, SiTiktok } from "react-icons/si";
import { Link } from "react-router-dom";
import ResponsiveImage from "@/components/ui/responsive-image";

const socialLinks = [
  {
    icon: SiX,
    href: "https://x.com/impause_app",
    label: "Follow us on X"
  },
  {
    icon: SiInstagram,
    href: "https://www.instagram.com/impause_app/?hl=en",
    label: "Follow us on Instagram"
  },
  {
    icon: SiTiktok,
    href: "https://www.tiktok.com/@impause_app",
    label: "Follow us on TikTok"
  }
];

export default function Footer() {
  return (
    <footer className="py-8 px-4 bg-white border-t">
      <div className="container max-w-6xl mx-auto">
        <div className="flex flex-col items-center gap-4">
          {/* Chrome Web Store Image */}
          <a 
            href="https://chromewebstore.google.com/detail/impause/deofpffeelbbckhopgmkgapcogaicahn" 
            target="_blank" 
            rel="noopener noreferrer"
            className="mb-4"
          >
            <img 
              src="/images/Chrome_Web_store.png" 
              alt="Available in the Chrome Web Store" 
              className="h-12 w-auto"
              width={120} 
              height={45}
              loading="lazy"
            />
          </a>
          
          <div className="flex justify-center items-center gap-8">
            {socialLinks.map((social) => (
              <a
                key={social.href}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#2D3436] hover:text-[#FF7063] transition-colors"
                aria-label={social.label}
              >
                <social.icon className="w-6 h-6" />
              </a>
            ))}
          </div>
          <div className="flex gap-4">
            <Link 
              to="/contact" 
              className="text-[#2D3436] hover:text-[#FF7063] transition-colors"
            >
              Contact Us
            </Link>
            <Link 
              to="/privacy-policy" 
              className="text-[#2D3436] hover:text-[#FF7063] transition-colors"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}